angular.module('galilai.creator').controller('MediaController', function ($scope, $http, $timeout, api, $rootScope, mediaService, fontsService) {
    const MAX_UPLOAD_SIZE_IN_MB = 500

    const spec = {
        'image': {
            kind: 'image',
            title: gettext('label.media_select_image'),
            tabs: [
                {
                    id: 'user',
                    name: gettext('tab.media_my_images'),
                    action: 'getMedias',
                    elements: {
                        upload: 'image/*',
                        project: true,
                        collection: true,
                        // Creating/modifying with AI only makes sense in the user's own
                        // library: that is where the generated image goes
                        studio: true,
                    },
                    actions: {
                        'select': true,
                        'download': true,
                        'remove': true,
                        'removeBg': true,
                        'favorite': true,
                        'unfavorite': false,
                    },
                },
                {
                    // Everything that came out of the studio, including what was generated
                    // and never used. Without this tab, whoever closed the studio without
                    // clicking "use" could never find the image they just paid for.
                    id: 'generated',
                    name: gettext('tab.media_generated'),
                    badge: gettext('tab.badge_new'),
                    action: 'getMedias',
                    // Same elements as the user tab, minus the upload: it is the same
                    // library, filtered. `preview` and `name` belong to audio — the first
                    // draws a play button over the image, the second writes the prompt on
                    // top of it.
                    elements: {
                        project: true,
                        collection: true,
                        studio: true,
                    },
                    actions: {
                        'select': true,
                        'download': true,
                        'remove': true,
                        'removeBg': true,
                        'favorite': true,
                        'unfavorite': false,
                    },
                },
                {
                    id: 'curated',
                    enabled: safeGetStorage('feature.curated') == 'true',
                    name: gettext('tab.media_images_database_curated'),
                    action: 'doSearch',
                    elements: {
                        search: {
                            source: 'curated',
                            default: 'social media',
                            paginated: true,
                            related: false,
                        },
                        radioFilter: {
                            kind: 'tabs',
                            model: 'imageKind',
                            options: [
                                { id: 'image-kind-any', value: 'any', label: gettext('tags.all') },
                                { id: 'image-kind-backgrounds', value: 'backgrounds', label: gettext('tag.curated_backgrounds'), icon: 'mdi-image-outline' },
                                { id: 'image-kind-people', value: 'people', label: gettext('tag.curated_people'), icon: 'mdi-account-outline' },
                                { id: 'image-kind-elements', value: 'elements', label: gettext('tag.curated_elements'), icon: 'mdi-shape-outline' },
                            ],
                        }
                    },
                    actions: {
                        'select': true,
                        'remove': false,
                        'removeBg': true,
                        'favorite': false,
                        'unfavorite': false,
                    },
                },
                {
                    id: 'pexels',
                    name: gettext('tab.media_images_database'),
                    action: 'doSearch',
                    elements: {
                        search: {
                            source: 'pexels',
                            default: 'social media',
                            paginated: true,
                            related: true,
                        }
                    },
                    actions: {
                        'select': true,
                        'remove': false,
                        'removeBg': true,
                        'favorite': false,
                        'unfavorite': false,
                    },
                },
                {
                    id: 'favorite',
                    name: gettext('tab.favorites'),
                    action: 'getMedias',
                    elements: {
                        upload: null,
                        project: true,
                        collection: false,
                    },
                    actions: {
                        'select': true,
                        'download': true,
                        'remove': false,
                        'removeBg': false,
                        'favorite': false,
                        'unfavorite': true,
                    },
                },
            ]
        },
        'video': {
            kind: 'video',
            title: gettext('label.media_select_video'),
            tabs: [
                {
                    id: 'user',
                    name: gettext('tab.media_my_videos'),
                    action: 'getMedias',
                    elements: {
                        upload: 'video/*',
                        project: true,
                        collection: true,
                    },
                    actions: {
                        'select': true,
                        'download': true,
                        'remove': true,
                        'removeBg': false,
                        'favorite': true,
                        'unfavorite': false,
                    },
                },
                {
                    id: 'pexels',
                    name: gettext('tab.media_videos_database'),
                    action: 'doSearch',
                    elements: {
                        search: {
                            source: 'pexels',
                            default: 'social media',
                            paginated: true,
                            related: true,
                        }
                    },
                    actions: {
                        'select': true,
                        'remove': false,
                        'removeBg': false,
                        'favorite': false,
                        'unfavorite': false,
                    },
                },
                {
                    id: 'favorite',
                    name: gettext('tab.favorites'),
                    action: 'getMedias',
                    elements: {
                        upload: null,
                        project: true,
                        collection: false,
                    },
                    actions: {
                        'select': true,
                        'download': true,
                        'remove': false,
                        'removeBg': false,
                        'favorite': false,
                        'unfavorite': true,
                    },
                },
            ]
        },
        'audio': {
            kind: 'audio',
            title: gettext('label.media_select_audio'),
            tabs: [
                {
                    id: 'audio_database',
                    name: gettext('tab.media_audio_database'),
                    action: 'doSearch',
                    elements: {
                        search: {
                            source: 'audio_database',
                            hideInput: true,
                            paginated: true,
                            suggestions: [
                                {
                                    value: '',
                                    label: gettext('tag.audio_all')
                                },
                                {
                                    value: 'upbeat',
                                    label: gettext('tag.audio_upbeat')
                                },
                                {
                                    value: 'happy',
                                    label: gettext('tag.audio_happy')
                                },
                                {
                                    value: 'inspiring',
                                    label: gettext('tag.audio_inspiring')
                                },
                                {
                                    value: 'chill',
                                    label: gettext('tag.audio_chill')
                                },
                                {
                                    value: 'sad',
                                    label: gettext('tag.audio_sad')
                                },
                                {
                                    value: 'romantic',
                                    label: gettext('tag.audio_romantic')
                                }
                            ]
                        },
                        preview: true,
                        name: true,
                        tags: true,
                        showTags: true,
                        radioFilter: {
                            kind: 'radio',
                            model: 'vocal',
                            options: [
                                { id: 'vocal-any', value: 'any', label: gettext('label.audio_vocal_any') },
                                { id: 'vocal-lyrics', value: 'lyrics', label: gettext('label.audio_vocal_lyrics') },
                                { id: 'vocal-instrumental', value: 'instrumental', label: gettext('label.audio_vocal_instrumental') },
                            ],
                        }
                    },
                    actions: {
                        'select': true,
                        'remove': false,
                        'removeBg': false,
                        'favorite': true,
                        'unfavorite': false,
                    }
                },
                {
                    id: 'user',
                    name: gettext('tab.media_my_audio'),
                    action: 'getMedias',
                    elements: {
                        upload: 'audio/*',
                        project: true,
                        collection: true,
                        preview: true,
                        name: true,
                    },
                    actions: {
                        'select': true,
                        'download': true,
                        'remove': true,
                        'removeBg': false,
                        'favorite': true,
                        'unfavorite': false,
                    }
                },
                {
                    id: 'favorite',
                    name: gettext('tab.favorites'),
                    action: 'getMedias',
                    elements: {
                        upload: null,
                        project: true,
                        collection: false,
                        preview: true,
                        name: true,
                    },
                    actions: {
                        'select': true,
                        'download': true,
                        'remove': false,
                        'removeBg': false,
                        'favorite': false,
                        'unfavorite': true,
                    },
                },
            ]
        },
        'elements': {
            kind: 'elements',
            title: gettext('label.media_select_elements'),
            tabs: [
                {
                    id: 'icons_db',
                    name: gettext('tab.media_icons_database'),
                    action: 'doSearch',
                    elements: {
                        search: {
                            source: 'icons_db',
                            default: gettext('icons.suggested.phone'),
                            _suggestions: [
                                {
                                    value: gettext('icons.suggested.phone'),
                                    label: gettext('icons.suggested.phone')
                                },
                                {
                                    value: gettext('icons.suggested.arrow'),
                                    label: gettext('icons.suggested.arrow')
                                },
                                {
                                    value: gettext('icons.suggested.heart'),
                                    label: gettext('icons.suggested.heart')
                                },
                                {
                                    value: gettext('icons.suggested.bubble'),
                                    label: gettext('icons.suggested.bubble')
                                },
                                {
                                    value: gettext('icons.suggested.shopping'),
                                    label: gettext('icons.suggested.shopping')
                                },
                                {
                                    value: gettext('icons.suggested.local'),
                                    label: gettext('icons.suggested.local')
                                },
                                {
                                    value: gettext('icons.suggested.star'),
                                    label: gettext('icons.suggested.star')
                                },
                            ],
                        },
                        preview: false,
                        name: false,
                        smallMedia: true,
                        hideActions: true,
                    },
                    actions: {
                        'select': true,
                        'remove': false,
                        'removeBg': false,
                        'favorite': false,
                        'unfavorite': false,
                    }
                },
            ]
        },
        'font': {
            kind: 'font',
            title: gettext('label.media_select_fonts'),
            tabs: [
                {
                    id: 'user',
                    name: gettext('tab.media_my_fonts'),
                    action: 'getMedias',
                    elements: {
                        upload: 'font/*',
                        project: true,
                        collection: false,
                        name: true,
                    },
                    actions: {
                        'select': true,
                        'download': true,
                        'remove': true,
                        'removeBg': false,
                        'favorite': true,
                        'unfavorite': false,
                    },
                },
                {
                    id: 'favorite',
                    name: gettext('tab.favorites'),
                    action: 'getMedias',
                    elements: {
                        upload: null,
                        project: true,
                        collection: false,
                        name: true,
                    },
                    actions: {
                        'select': true,
                        'download': true,
                        'remove': false,
                        'removeBg': false,
                        'favorite': false,
                        'unfavorite': true,
                    },
                },
            ]
        },
        'product': {
            kind: 'product',
            title: gettext('label.media_select_product'),
            titleEdit: gettext('label.media_edit_products'),
            tabs: [
                {
                    id: 'user',
                    name: gettext('tab.media_my_products'),
                    action: 'getMedias',
                    elements: {
                        viewMode: true,
                        createDropdown: {
                            labelNotFound: gettext('label.no_products_found'),
                            upload: {
                                accept: 'image/*',
                                forceKind: 'product',
                            },
                            items: [
                                {
                                    label: gettext('btn.create_text_only'), 'action': $scope.create, args: ['text'],
                                    icon: 'mdi mdi-text-box-plus-outline'
                                },
                                {
                                    label: gettext('btn.create_with_images'), 'action': $scope.create, args: ['image'],
                                    icon: 'mdi mdi-upload-circle-outline',
                                },
                                {
                                    label: gettext('btn.create_full_signup'), 'action': $scope.create, args: ['full'],
                                    icon: 'mdi mdi-format-list-bulleted-type'
                                },
                            ]
                        },
                        project: false,
                        collection: false,
                        name: true,
                    },
                    actions: {
                        'select': true,
                        'download': true,
                        'edit': true,
                        'remove': true,
                        'removeBg': false,
                        'favorite': true,
                        'unfavorite': false,
                    },
                },
                {
                    id: 'favorite',
                    name: gettext('tab.favorites'),
                    action: 'getMedias',
                    elements: {
                        upload: null,
                        project: true,
                        collection: false,
                        name: true,
                    },
                    actions: {
                        'select': true,
                        'download': true,
                        'remove': false,
                        'removeBg': false,
                        'favorite': false,
                        'unfavorite': true,
                    },
                },
            ]
        },
    }

    $scope.view = {}
    $scope.previewMap = {}

    const HOME_COLLECTION = {
        'value': '__home__',
        'label': gettext('label.folder_home')
    }
    $scope.initView = function(kind, data) {
        $scope.view = {
            globalState: null,
            viewMode: 'grid',
            spec: JSON.parse(JSON.stringify(spec[kind], null, 2)),
            currentTab: null,
            uploading: false,
            selectedMedia: null,
            customAction: null,
            loading: false,
            medias: [],
            relatedSearches: [],
            nextPage: null,
            radioFilters: {},
            tags: [],
            tag: null,
            collections: [
                JSON.parse(JSON.stringify(HOME_COLLECTION, null, 2))
            ],
            collection: '__home__',
        }

        // Add $scope.create to action of createDropdown
        for (let tab of $scope.view.spec.tabs) {
            if (tab?.elements?.createDropdown?.items && Array.isArray(tab.elements.createDropdown.items)) {
                for (let item of tab.elements.createDropdown.items) {
                    item.action = $scope.create
                }
            }
        }

        try {
            $scope.view.spec.tabs.forEach(function(tab) {
                if (tab.elements.search && tab.elements.search.default) {
                    let defaultValue = $scope.getDefault(tab.id)
                    if (defaultValue != 'null' && defaultValue != 'undefined' && defaultValue && defaultValue.trim().length > 0) {
                        tab.elements.search.default = defaultValue
                    }
                }
            })
        } catch (e) {
            // TASK - No handling
        }

        // Init view mode
        try {
            if (data?.global) {
                $scope.view.globalState = data.global || null
            }

            if ($scope?.view?.globalState?.config?.media?.[kind]?.viewMode) {
                $scope.view.viewMode = $scope?.view?.globalState?.config?.media[kind]?.viewMode
            } else if (kind == 'product' && $scope?.view?.globalState?.serviceType) {
                $scope.view.viewMode = $scope?.view?.globalState?.serviceType == 'visual' ? 'grid' : 'table'
            }
        } catch (e) {
            console.error('Failed to init view mode', e)
        }

        track('Editor Media Show', {
            kind: kind
        })

        initModalAdjust()
    }

    $scope.changeViewMode = function(viewMode) {
        $scope.view.viewMode = viewMode
        // Update global state
        if ($scope?.view?.globalState) {
            if (!$scope.view.globalState.config) {
                $scope.view.globalState.config = {}
            }

            if (!$scope.view.globalState.config.media) {
                $scope.view.globalState.config.media = {}
            }
            let kind = $scope?.view?.spec?.kind
            if (!kind) {
                return
            }
            if (!$scope.view.globalState.config.media[kind]) {
                $scope.view.globalState.config.media[kind] = {}
            }
            let key = 'config.media.' + kind + '.viewMode'
            $scope.saveProjectInfo({
                [key]: viewMode
            })
            $scope.view.globalState.config.media[kind].viewMode = viewMode
        }
    }

    $scope.saveProjectInfo = function(data) {
        if (!$scope.view.projectId) {
            return
        }
        api.updateProjectGlobalSingle($scope.view.projectId, data)
        .catch(function() {
            // TASK - No handling
        })
    }

    function initModalAdjust() {
        window.addEventListener('resize', adjustModal);
        let modal = document.querySelector('#images-modal');
        // On hidden
        modal.addEventListener('hidden.bs.modal', function() {
            window.removeEventListener('resize', adjustModal);
        })
    }

    function adjustModal() {
        $timeout(function() {
            const modalContent = document.querySelector('#images-modal .modal-content');
            const mediaScrollWrapper = document.querySelector('#images-modal .media-scroll-wrapper');
            const windowHeight = window.innerHeight;

            let offset = 200
            offset = IS_APP ? 200 + 60 : offset // Account for app header
            if (mediaScrollWrapper.scrollHeight > windowHeight - offset) {
                mediaScrollWrapper.style.maxHeight = (windowHeight - offset) + 'px';
                mediaScrollWrapper.style.overflowY = 'scroll';
            } else {
                mediaScrollWrapper.style.maxHeight = 'none';
            }
        }, 200);
    }

    $scope.$watch('config', function() {
        if ($scope.config && $scope.config.kind) {
            $scope.initView($scope.config.kind)

            if ($scope.config.projectId) {
                $scope.view.projectId = $scope.config.projectId
            }
            $scope.init()
        }
    })

    // Pushes back the modal left underneath, so the two do not compete
    function dimModalsBehind(dim) {
        const modals = document.querySelectorAll('.modal.show')
        modals.forEach(function(modal) {
            if (modal.id === 'images-modal') {
                return
            }
            modal.classList.toggle('is-dimmed', dim)
        })
    }

    $rootScope.$on('media.show', function(event, data) {
        if ($scope.config && $scope.config.kind) {
            return
        }
        if (data?.openModal) {
            let modalElement = angular.element('#images-modal');
            if (modalElement) {
                modalElement.modal('show')
                // Opening from inside another modal has to say it comes on top: the
                // lookalike picker sits at 250000 and this one would fall behind with the
                // default value
                modalElement.css('z-index', data.zIndex || 200000)
                dimModalsBehind(true)
                modalElement.off('hidden.bs.modal.picker').on('hidden.bs.modal.picker', function() {
                    dimModalsBehind(false)
                })
            }
        }
        let isSameMediaKind = $scope?.view?.spec?.kind == data.kind && $scope.view.projectId == data.projectId
            && !data.tabs
        if (!isSameMediaKind) {
            $scope.initView(data.kind, data)
        }
        // Whoever opens the picker may limit the tabs. It is what keeps the lookalike from
        // offering the stock library: an external search result has no media id, and the
        // choice would be silently dropped on the way back.
        if (data && Array.isArray(data.tabs) && data.tabs.length > 0) {
            $scope.view.spec.tabs = $scope.view.spec.tabs.filter(function(tab) {
                return data.tabs.indexOf(tab.id) !== -1
            })
        }
        if (data && data.projectId) {
            $scope.view.projectId = data.projectId
        }
        $scope.view.selectedSource = null
        $scope.view.customAction = null
        if (data && data.source) {
            $scope.view.selectedSource = data.source
        }
        if (data && data.customAction) {
            $scope.view.customAction = data.customAction
        }
        if (data && data.multiple) {
            $scope.view.multiple = data.multiple
        }
        // Whoever opens the picker may ask for the entry tab. Without it the lookalike's
        // voice would land on the stock music tab, which is exactly what it is not.
        $scope.view.startTab = (data && data.tab) || null
        // The audio plan gate exists because of the licensed music library. Whoever opens
        // the picker for something else (the video's voice sample, already gated by the
        // video plan) asks for the exemption explicitly.
        $scope.view.planGate = !(data && data.planGate === false)
        if (!isSameMediaKind) {
            $scope.init()
        } else {
            if ($scope.view.startTab) {
                const tab = findTab($scope.view.startTab)
                if (tab && tab !== $scope.view.currentTab) {
                    $scope.changeMediaTab(tab)
                }
            }
            // Deselect all existing medias
            if ($scope.view.medias && Array.isArray($scope.view.medias)) {
                $scope.view.medias.forEach(function(media) {
                    media.active = false
                })
                $scope.view.selectedMedia = []
            }
            adjustModal()
        }
    })
    /**
     * Opens the image studio. In 'modify' it carries the selected image as the source; in
     * 'create' it goes with nothing. The project and the folder travel along so the
     * generated image is born where the user is looking.
     */
    $scope.openStudio = function(mode) {
        let source = null
        if (mode == 'modify') {
            let selected = $scope.view.selectedMedia && $scope.view.selectedMedia[0]
            if (!selected) {
                return
            }
            source = { _id: selected._id, url: selected.data && selected.data.url }
        }
        $rootScope.$broadcast('media.studio.show', {
            mode: mode,
            source: source,
            projectId: $scope.view.projectId,
            collection: $scope.view.collection,
            kind: $scope.view.spec.kind,
        })
    }

    // The studio finished and the user asked to use the image: select and confirm, which
    // is what they came to the picker to do anyway.
    $rootScope.$on('media.studio.use', function(event, media) {
        if (!media) {
            return
        }
        // The studio is also opened from outside here (the lookalike photo variation):
        // without this check the picker would confirm a selection nobody asked for
        if (media.origin) {
            return
        }
        $scope.view.selectedMedia = [media]
        $scope.confirm()
    })

    $rootScope.$on('media.item.created', function(event, data) {
        if (!data || data.kind != $scope.view.spec.kind) {
            return
        }
        $scope.getMedias()
    })

    function findTab(id) {
        return $scope.view.spec.tabs.find(function (tab) { return tab.id == id })
    }

    $scope.init = function() {
        $scope.getCollections()
        $scope.getProjects()
        $scope.changeMediaTab(findTab($scope.view.startTab) || $scope.view.spec.tabs[0])
    }

    $scope.changeMediaTab = function(tab) {
        $scope.view.currentTab = tab
        if (tab.elements && tab.elements.search && tab.elements.search.default && !$scope.view.searchInput) {
            $scope.view.searchInput = tab.elements.search.default
        }
        $scope[tab.action]()
    }

    $scope.create = function(kindCreate) {
        if (Array.isArray(kindCreate)) {
            kindCreate = kindCreate[0]
        }
        if (!$scope.view.currentTab.elements.create && !$scope.view.currentTab.elements.createDropdown) {
            return
        }
        if (kindCreate == 'image' ){
            document.getElementById('createDropdownUpload').click();
            return
        }
        if (kindCreate == 'text' ){
            $rootScope.$emit('media.item.show', {
                source: 'media',
                kind: 'product-text',
                projectId: $scope.view.projectId,
                collection: $scope.view.collection,
            })
            return
        }
        $rootScope.$emit('media.item.show', {
            source: 'media',
            kind: $scope.view.spec.kind,
            projectId: $scope.view.projectId,
            collection: $scope.view.collection,
        })
    }

    $scope.editMedia = function(media) {
        if (!$scope.view.currentTab.actions.edit) {
            return
        }
        $rootScope.$emit('media.item.edit', {
            source: 'media',
            kind: $scope.view.spec.kind,
            projectId: $scope.view.projectId,
            collection: $scope.view.collection,
            item: media,
        })
    }

    // Refactor
    $scope.uploadMedia = function(file, forceKind) {
        if (!file) {
            showError(gettext('error.invalid.file_type'))
            return;
        }
        // Limit number max files

        var formData = new FormData();
        for (var i = 0; i < file.length; i++) {
            formData.append('media', file[i]);
            formData.append(`name[${i}]`, file[i].name);
        }

        // Validate max size 100mb (what happens if there are multiple files?, check sum?)
        // Validate max number of files
        let totalSize = 0
        for (var i = 0; i < file.length; i++) {
            totalSize += file[i].size
        }

        if (totalSize > MAX_UPLOAD_SIZE_IN_MB * 1024 * 1024) {
            showError(gettext('error.invalid.max_size', MAX_UPLOAD_SIZE_IN_MB + 'MB'))
            return
        }

        formData.append('projectId', $scope.view.projectId);
        formData.append('collection', $scope.view.collection);
        if (forceKind) {
            formData.append('forceKind', forceKind);
            if (getCurrentCurrency()) {
                formData.append('currency', getCurrentCurrency());
                formData.append('country', getCurrentCountry());
            }
        }
        let token = localStorage.getItem('auth.token');

        $scope.view.uploading = true
        // TODO - Refactor
        $http({
          method: 'POST',
          url: window.BASE_URL + '/api/media/upload',
          data: formData,
          headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': undefined
          },
          transformRequest: angular.identity
        })
        .then(function(response) {
            if (response?.data?.errors?.filter(err => err == 'invalid_image_type').length > 0) {
                showError(gettext('error.broken.media'))
            }
            $scope.view.uploading = false
            $scope.getMedias()
            $scope.getCollections()
        })
        .catch(function(error) {
            $scope.view.uploading = false
            showError(gettext('error.invalid.image'))
        }).finally(function() {
            $scope.view.uploading = false
            // Clear input #imageInput
            angular.element('#imageInputModal').val(null);
        })
    }

    $scope.selectMedia = function(media) {
        if ($scope.view.multiple) {
            if (!$scope.view.selectedMedia) {
                $scope.view.selectedMedia = []
            }
            const index = $scope.view.selectedMedia.findIndex(selected => selected._id === media._id);
            if (index > -1) {
                $scope.view.selectedMedia.splice(index, 1);
                media.active = false;
            } else {
                $scope.view.selectedMedia.push(media);
                media.active = true;
            }
        } else {
            $scope.view.medias.forEach(function(media) {
                media.active = false;
            });
            media.active = true;
            $scope.view.selectedMedia = [media];
        }

        if ($scope.onSelect) {
            $scope.onSelect($scope.view.selectedMedia);
        }
        $timeout(angular.noop)
    };

    $scope.selectSuggestion = function(suggestion) {
        $scope.view.searchInput = suggestion.value
        $scope.doSearch()
    }

    $scope.saveSearch = function() {
        try {
            localStorage.setItem('media.search.' + $scope.view.spec.kind + '.' + $scope.view.currentTab.id, $scope.view.searchInput)
        } catch (e) {
            // TASK - No handling
        }
    }

    $scope.getDefault = function(tabId) {
        try {
            return localStorage.getItem('media.search.' + $scope.view.spec.kind + '.' + tabId)
        } catch (e) {
            return ''
        }
    }

    let timerSearchRelated = null
    $scope.searchRelated = function() {
        if (timerSearchRelated) {
            $timeout.cancel(timerSearchRelated)
        }
        timerSearchRelated = $timeout(function() {
            $scope.saveSearch()
            api.relatedSearch({
                query: $scope.view.searchInput,
            }).then(function(response) {
                $timeout(function() {
                    $scope.view.relatedSearches = response.data
                    console.log('Related searches', $scope.view.relatedSearches)
                })
            }).catch(function() {
                // TASK - No handling
            })
        }, 500)
    }

    $scope.doSearch = function(page) {
        $scope.view.loading = true

        page = page || 1
        if (page == 1) {
            $scope.searchRelated()
        }
        let searchParams = {
            kind: $scope.view.spec.kind,
            source: $scope.view.currentTab.elements.search.source,
            query: $scope.view.searchInput,
            page: page,
        }
        // Check if tags are enabled
        if ($scope.view?.tag && $scope?.view?.currentTab?.elements?.tags) {
            searchParams.tag = $scope.view.tag
        }

        try {
            if ($scope.view.radioFilters) {
                for (const filter in $scope.view.radioFilters) {
                    if ($scope.view.radioFilters[filter] && $scope.view.radioFilters[filter] != 'any') {
                        searchParams[filter] = $scope.view.radioFilters[filter]
                    }
                }
            }
        } catch (e) {
            console.error('Failed to apply radio filters', e)
        }

        api.searchMedia(searchParams).then(function(response) {
            $timeout(function() {
                if (page == 1) {
                    $scope.view.medias = response.data.medias
                } else {
                    $scope.view.medias = $scope.view.medias.concat(response.data.medias)
                }
                if (response.data.tags) {
                    $scope.view.tags = response.data.tags.map(function(tag) {
                        return {
                            value: tag,
                            label: tag
                        }
                    })
                }
                $scope.view.nextPage = response.data.next
                $scope.afterFetchingMedias($scope.view.medias)
                adjustModal()
            })
        }).catch(function() {
            // TASK - No handling
        })
        .finally(function() {
            $scope.view.loading = false
            $timeout(angular.noop)
        })
    }

    $scope.onScroll = function() {
        if ($scope.view.loading) {
            return
        }
        $scope.loadNextPage()
    }

    $scope.loadNextPage = function() {
        if ($scope.view.loading) {
            return
        }
        if (!$scope.view.nextPage) {
            return
        }
        $scope.doSearch($scope.view.nextPage)
    }

    $scope.afterFetchingMedias = function(medias) {
        // If kind is font load fonts
        if ($scope.view.spec.kind == 'font') {
            medias.map(function(media) {
                let fullFontName = media.data.url.split('/').pop()
                fontsService.loadDynamic(fullFontName)
            })
        }
    }

    $scope.getMedias = function() {
        $scope.view.loading = true
        let params = {}
        if ($scope.view.projectId) {
            params.projectId = $scope.view.projectId
        }
        if ($scope.view.collection && typeof $scope.view.collection !== 'undefined' && $scope.view.collection.trim().length > 0) {
            params.collection = $scope.view.collection
        }
        params.kind = $scope.view.spec.kind

        if ($scope.view.currentTab && $scope.view.currentTab.id) {
            params.tab = $scope.view.currentTab.id
        }

        api.getMedias(params).then(function(response) {
            $timeout(function() {
                $scope.view.medias = response.data
                $scope.afterFetchingMedias($scope.view.medias)
                adjustModal()
            })
        })
        .catch(function() {
            // TASK - No handling
        })
        .finally(function() {
            $scope.view.loading = false
            $timeout(angular.noop)
        })
    }

    $scope.onChangeProject = function() {
        $timeout(function() {
            $scope.getMedias()
        })
    }

    $scope.onChangeCollection = function() {
        $timeout(function() {
            $scope.getMedias()
        })
    }

    $scope.showAllMedias = function() {
        $timeout(function() {
            $scope.view.projectId = null
            $scope.view.collection = null
            $scope.getMedias()
        })
    }

    $scope.getCollections = function() {
        api.getCollections($scope.view.spec.kind).then(function(response) {
            // Merge with collections
            let collections = [
                JSON.parse(JSON.stringify(HOME_COLLECTION, null, 2))
            ]
            collections = collections.concat(response.data.collections.map(function(collection) {
                return {
                    value: collection,
                    label: collection
                }
            }))

            $scope.view.collections = collections
            $timeout(angular.noop)
        })
        .catch(function() {
        })
    }

    $scope.getProjects = function() {
        api.getProjects().then(function(response) {
            $timeout(function() {
                $scope.projects = response.data
                $scope.view.projects = response.data.map(function(project) {
                    return {
                        value: project._id,
                        label: project.name
                    }
                })
            })
        })
        .catch(function() {
            // TASK - No handling
        })
    }

    $scope.removeMedia = function(media) {
        let mediaId = media._id

        showConfirm(gettext('label.are_you_sure'), null, function(status) {
            if (status) {
                angular.noop()
                api.removeMedia(mediaId).then(function(response) {
                    $scope.view.medias = $scope.view.medias.filter(function(media) {
                        return media._id != mediaId
                    })
                    $timeout(angular.noop)
                }).catch(function(response) {
                    if (response?.data?.error == 'media_in_use') {
                        showError(gettext('error.media_in_use'))
                    }
                    // TASK - No handling
                })
            }
        })
    }

    $scope.removeSelected = function() {
        if (!$scope.view.selectedMedia || $scope.view.selectedMedia.length === 0) {
            return;
        }

        showConfirm(gettext('label.are_you_sure'), null, function(status) {
            if (!status) return;

            const selected = $scope.view.selectedMedia;
            const promises = selected.map(media =>
                api.removeMedia(media._id)
                    .then(() => ({ success: true, media }))
                    .catch((error) => ({ success: false, media, error }))
            );

            Promise.allSettled(promises).then(results => {
                const successful = [];
                let hasMediaInUseError = false;

                results.forEach(result => {
                    const value = result.value || result.reason; // allSettled always has value
                    if (value.success) {
                        successful.push(value.media._id);
                    } else {
                        if (value?.error?.data?.error === 'media_in_use') {
                            hasMediaInUseError = true;
                        }
                    }
                });

                // Remove only successful deletions
                $scope.view.medias = $scope.view.medias.filter(media =>
                    !successful.includes(media._id)
                );

                // Clear selection
                $scope.view.selectedMedia = null;

                // Show error if any media was in use
                if (hasMediaInUseError) {
                    showError(gettext('error.media_in_use'));
                }

                $timeout(angular.noop); // trigger digest
            });
        });
    };

    $scope.favoriteMedia = function(media) {
        let mediaId = media._id
        if (!$scope.view.projectId) {
            showError(gettext('error.missing_project_favorite'))
            return
        }
        api.addFavorite({
            kind: $scope.view.spec.kind,
            projectId: $scope.view.projectId,
            value: mediaId
        }).then(function(response) {
            if (response.data && response.data.status && response.data.status == 'success') {
                showSuccess(gettext('label.success_generic'))
            } else {
                showError(gettext('error.generic'))
            }
        }).catch(function() {
            showError(gettext('error.generic'))
        })
    }

    $scope.unfavoriteMedia = function(media) {
        let mediaId = media._id
        if (!$scope.view.projectId) {
            showError(gettext('error.missing_project_favorite'))
            return
        }
        api.removeFavorite({
            kind: $scope.view.spec.kind,
            projectId: $scope.view.projectId,
            value: mediaId
        }).then(function(response) {
            if (response.data && response.data.status && response.data.status == 'success') {
                showSuccess(gettext('label.success_generic'))
                $scope.getMedias()
            } else {
                showError(gettext('error.generic'))
            }
        }).catch(function() {
            showError(gettext('error.generic'))
        })
    }

    /**
     * Downloads the media as a file.
     *
     * It goes through a blob instead of an <a download> pointing at S3 because the
     * `download` attribute is ignored on a cross-origin URL: the browser would open the
     * image in a tab instead of saving it, and the filename would become the storage hash.
     *
     * In the app the path is another one (`_system`), which is how the rest of the product
     * hands files to the user — and it is also the fallback when the browser refuses to
     * read the file directly.
     */
    $scope.downloadMedia = function(media) {
        const url = media?.data?.url
        if (!url) {
            return
        }

        function abrirFora() {
            window.open(url, IS_APP ? '_system' : '_blank')
        }

        if (IS_APP) {
            abrirFora()
            return
        }

        const nome = (media.data.name || 'galilai').replace(/[\\/:*?"<>|]/g, '').trim() || 'galilai'
        const ext = (url.split('?')[0].split('.').pop() || 'jpg').slice(0, 5)

        fetch(url)
            .then(function(response) {
                if (!response.ok) {
                    throw new Error('http_' + response.status)
                }
                return response.blob()
            })
            .then(function(blob) {
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = nome + '.' + ext
                document.body.appendChild(link)
                link.click()
                link.remove()
                setTimeout(function() {
                    URL.revokeObjectURL(link.href)
                }, 1000)
            })
            .catch(function(error) {
                console.error('Error downloading media:', error)
                abrirFora()
            })
    }

    $scope.removeMediaBackground = function(media) {
        $rootScope.mainLoading = true

        api.removeMediaBackground({
            url: media.data.url,
            projectId: $scope.view.projectId,
            collection: $scope.view.collection,
        }).then(function(response) {
            $scope.changeMediaTab($scope.view.spec.tabs[0])
            $scope.resetScroll()
        }).catch(function() {
            // TASK - No handling
        }).finally(function(){
            $rootScope.mainLoading = false
            $timeout(angular.noop)
        })
    }

    $scope.resetScroll = function() {
        let scrollWrapper = document.querySelectorAll('.media-scroll-wrapper')
        // Reset scroll for all
        scrollWrapper.forEach(function(wrapper) {
            wrapper.scrollTop = 0
        })
    }

    $scope.confirm = function(actionType) {
        let maxUpgradeKinds = [
            'audio', 'video',
        ]
        if ($scope.view.planGate !== false && !$rootScope.isMaxCustomer() && maxUpgradeKinds.indexOf($scope.view.spec.kind) != -1 && $scope.view.selectedMedia.length > 0) {
            if ($scope.view.spec.kind == 'audio') {
                $rootScope.showUpgrade('Select Audio')
            } else if ($scope.view.spec.kind == 'video') {
                $rootScope.showUpgrade('Select Video')
            }
            return false
        }
        let data = $scope.view.selectedMedia.map(function(media) {
            return Object.assign({}, {_id: media._id}, media.data)
        })
        $rootScope.$broadcast('media.selected', data, $scope.view.selectedSource, actionType)
        angular.element('#images-modal').modal('hide')
    }

    $scope.getMediaStyle = function(media) {
        if ($scope.view.spec.kind == 'image' || $scope.view.spec.kind == 'product') {
            if ($scope.view.viewMode == 'table') {
                return {}
            }
            let mediaURL = media.data.url
            if (!mediaURL || mediaURL.trim().length == 0) {
                mediaURL = '/assets/images/creator/placeholder.png'
            }
            if (mediaURL.includes('images.pexels') && media.data.thumb) {
                mediaURL = media.data.thumb
            }
            return {
                'background-image': 'url(' + mediaURL + '), linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%, #ccc), linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%, #ccc)',
            }
        }
        if ($scope.view.spec.kind == 'video') {
            let mediaURL = media.data.thumb
            return {
                'background-image': 'url(' + mediaURL + '), linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%, #ccc), linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%, #ccc)',
            }
        }
        if ($scope.view.spec.kind == 'elements') {
            return {
                'background-image': 'url(' + media.data.url + ')',
            }
        }
        if ($scope.view.spec.kind == 'audio') {
            return {
                'width': '200px',
                'height': '80px',
            }
        }
        if ($scope.view.spec.kind == 'font') {
            return {
                'width': '200px',
                'height': '50px',
            }
        }
        return {}
    }

    $scope.getMediaNameStyle = function(media) {
        if ($scope.view.spec.kind == 'font') {
            let fullName = media.data.url.split('/').pop()
            return {
                'font-family': `"${fullName}"`,
                'font-size': '16px',
                'line-height': '50px',
            }
        }
        return {}
    }
    $scope.previewMedia = function(media, $event) {
        // Mark other medias as not previewing
        $scope.view.medias.forEach(function(m) {
            if (m._id != media._id && m.previewing) {
                m.previewing = false
            }
        })
        $event.stopPropagation()
        media.previewing = true
        mediaService.previewAudio(media, function() {
            $timeout(function() {
                media.previewing = false
            })
        })
    }
})
